module.exports = __webpack_public_path__ + "media/יש.a16f201e.mp3";